import React, { PropTypes } from "react";
import CpdRecordedItem from "components/CpdLocker/CpdRecordedItem";
import { connect } from "react-redux";
import { push } from "redux-router";
import actions from "actions";
import constants from "constants";
import storage from "services/storage.js";
import moment from "moment";
import { Link } from "react-router";

const { RECORDED_WEBINARS, MODAL_TYPE_QUIZ } = constants;

const {
  loadUsersWebinarsSaga,
  cleanUsersWebinars,
  showModal,
  loadWebinarsAvailableYearsSaga,
} = actions;

class CpdRecorded extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      isMobile: !window.matchMedia("(min-width: 800px)").matches,
      activeYear: new Date().getFullYear(),
    };
  }
  onItemClick = (itemId) => {
    this.props.dispatch(push(`/webinars/${itemId}`));
  };

  componentWillMount() {
    this.props.loadWebinars(this.state.page, this.state.activeYear);
    this.props.loadYearsWebinars();
  }

  nextPage = () => {
    this.setState(
      {
        ...this.state,
        page: this.state.page + 1,
      },
      () => {
        this.props.loadWebinars(this.state.page, this.state.activeYear);
      }
    );
  };

  onYearClick = (year) => {
    this.setState({
      page: 1,
      activeYear: year,
    });
    this.props.loadWebinars(1, year);
  };

  componentWillUnmount() {
    this.props.cleanWebinars();
  }

  showQuizModal = (webinar) => {
    this.props.showQuizModal({
      webinar: webinar,
    });
  };

  render() {
    const token = storage.getSessionData().session.token;
    const { int_cpds, ext_cpds, from, to } = this.props.cpds || {};

    return (
      <div>
        <div className="container_tabs cpd-recorded">
          <ul className="tabs cpd_tabs">
            <li className="tab">
              <Link activeClassName={"active"} to="/cpd/live">
                Live Meetings
              </Link>
            </li>
            <li className="tab">
              <Link activeClassName={"active"} to="/cpd/recorded">
                On-Demand Meetings
              </Link>
            </li>
          </ul>
          <div className="cpd-years-container">
            {this.props.years.map((year) => (
              <button
                className={`button_classic-years ${
                  this.state.activeYear === year && "active"
                }`}
                onClick={() => this.onYearClick(year)}
              >
                {year}
              </button>
            ))}
          </div>
        </div>
        <div id="recorded" className="main_live col s12">
          <p className="live_total">
            {from &&
              to &&
              `CPD Year: ${moment(from).format("MMMM YY")} – ${moment(
                to
              ).format("MMMM YY")}`}
            <br />
            {ext_cpds && <span>{`Ext CPD Points Total: ${ext_cpds}`}</span>}
            {ext_cpds && <br />}
            {int_cpds && <span>Int CPD Points Total: {int_cpds}</span>}
          </p>
          <div className="container_live">
            {this.props.webinars.map((webinar) => (
              <CpdRecordedItem
                webinar={webinar}
                token={token}
                onClick={() => this.onItemClick(webinar.id)}
                takeCpdQuiz={this.showQuizModal}
                isMobile={this.state.isMobile}
              />
            ))}
          </div>
          {this.props.pages > this.state.page && (
            <a
              className="more_item"
              href="javascript:void(0)"
              onClick={this.nextPage}
            >
              LOAD MORE
            </a>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  webinarsYears: state.webinars.userWebinarsAvailableYears,
  webinars: state.webinars.usersWebinars[RECORDED_WEBINARS].values,
  arguments: arguments,
  cpds: state.webinars.usersWebinars[RECORDED_WEBINARS].cpds,
  pages: state.webinars.usersWebinars[RECORDED_WEBINARS].pages,
  years: state.webinars.usersWebinars[RECORDED_WEBINARS].years || [],
});
const mapDispatchToProps = (dispatch) => ({
  loadYearsWebinars: () => dispatch(loadWebinarsAvailableYearsSaga()),
  loadWebinars: (page, year) =>
    dispatch(loadUsersWebinarsSaga(RECORDED_WEBINARS, page, year)),
  dispatch: dispatch,
  cleanWebinars: () => dispatch(cleanUsersWebinars()),
  showQuizModal: (contentProps) =>
    dispatch(showModal(MODAL_TYPE_QUIZ, contentProps)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CpdRecorded);



// WEBPACK FOOTER //
// ./src/containers/CpdLocker/CpdRecorded.js